import { yup } from '@framework/validation/initYup.ts';
import { RuleType } from '../../IRule.ts';
import { type IRuleType } from '../../IRuleType.ts';
import { PositiveRuleComponent } from './PositiveRuleComponent.tsx';

const configValidator = yup
  .object({
    value: yup.boolean().notRequired().label('Numero positivo'),
    customMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown();

type IRulePositiveType = yup.InferType<typeof configValidator>;

export const PositiveRule: IRuleType<IRulePositiveType> = {
  type: RuleType.Positive,
  name: 'Numero positivo',
  configComponent: PositiveRuleComponent,
  configValidator,
  validator: (schema, rule) => {
    if (!rule?.value) return schema;

    return (schema as yup.NumberSchema).positive(
      rule.customMessage ?? undefined,
    );
  },
};
